<!-- Development steps -->
<div class="development">
    <!-- Title -->
    <div class="title">
        <h2 class="development__title">
            How was the Screen For EPI in CP tool developed?<span>1-3</span>
        </h2>
        <p class="development__copy">The following 7 steps highlight how the screening tool was developed to predict whether patients with definite chronic pancreatitis (CP) have exocrine pancreatic insufficiency (EPI).</p>
    </div>
    <!-- Table 1 -->
    <app-table1 *ngIf="tables[1]" (closeModalEvent)="closeTable()" ></app-table1>
    <div class="variable variable--1">
        <img src="assets/images/patient-selection.svg" class="variable-graphic" alt="Patient selection">
        <h3 class="development__subtitle">
            1. Patient selection
        </h3>
        <p class="development__copy">Expert pancreatologists at 6 pancreatitis centers enrolled 274 patients with definite CP of whom, 160 had EPI and 114 patients did not.</p>
        <app-button text="View patient demographics" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('1')" ></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
    </div>
    <!-- Table 2 -->
    <app-table2 *ngIf="tables[2]" (closeModalEvent)="closeTable()" ></app-table2>
    <div class="variable variable--2">
        <img src="assets/images/variable-selection.svg" class="variable-graphic" alt="Variable selection">
        <h3 class="development__subtitle">
            2. Variable selection
        </h3>
        <p class="development__copy">Of up to 64 candidate patient variables  (predictors) that were included in the study, 49 were suitable for use in predictive modeling.</p>
        <app-button text="View candidate predictors" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('2')" text="View candidate predictors"></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
        <div class="bg-graphic desktop-only">
            <div class="c-graphics">
                <picture class="oval">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-01-desktop.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-01-desktop@2x.png">
                    <img src="assets/graphics/bg-oval-01-desktop@3x.png" alt="Oval graphic">
                </picture>
                <picture class="infographic">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/infographic-01.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/infographic-01@2x.png">
                    <img src="assets/graphics/infographic-01@3x.png" alt="Infographic">
                </picture>
            </div>
        </div>
        <div class="bg-graphic-mobile mobile-only">
            <picture>
                <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-01-mobile.png">
                <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-01-mobile@2x.png">
                <img src="assets/graphics/bg-oval-01-mobile@3x.png" alt="Oval graphic">
            </picture>
        </div>
    </div>
    <!-- Table 3 -->
    <app-table3 *ngIf="tables[3]" (closeModalEvent)="closeTable()" ></app-table3>
    <div class="variable variable--3">
        <img src="assets/images/cart-modeling.svg" class="variable-graphic" alt="Cart modeling">
        <h3 class="development__subtitle">
            3. CART modeling
        </h3>
        <p class="development__copy">First, Classification and Regression Tree (CART) predictive modeling was used to establish a rank list of all variables based on importance. Second, the CART model was trained and tuned using data of all 274 patients, with the objective to built a decision tree that has the smallest number of variables and the lowest EPI misclassification rate.</p>
        <app-button text="View predictors used" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('3')" ></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
        <div class="bg-graphic desktop-only">
            <div class="c-graphics left-align">
                <picture class="oval">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-02-desktop.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-02-desktop@2x.png">
                    <img src="assets/graphics/bg-oval-02-desktop@3x.png" alt="Oval graphic">
                </picture>
                <picture class="infographic">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/infographic-02.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/infographic-02@2x.png">
                    <img src="assets/graphics/infographic-02@3x.png" alt="Infographic">
                </picture>
            </div>
        </div>
        <div class="bg-graphic-mobile mobile-only">
            <picture>
                <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-02-mobile.png">
                <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-02-mobile@2x.png">
                <img src="assets/graphics/bg-oval-02-mobile@3x.png" alt="Oval graphic">
            </picture>
        </div>
    </div>
    <!-- Table 4 -->
    <app-table4 *ngIf="tables[4]" (closeModalEvent)="closeTable()" ></app-table4>
    <div class="variable variable--4">
        <img src="assets/images/performance-characteristics.svg" class="variable-graphic" alt="Performance characteristics">
        <h3 class="development__subtitle">
            4. Performance characteristics of optimal CART <span>(49 predictors)</span>
        </h3>
        <ul class="development__list">
            <li>EPI misclassification rate (training error rate): 0.1533</li>
            <li>Sensitivity: 89%</li>
            <li>Specificity: 79%</li>
            <li>Positive predictive value (PPV): 86%</li>
            <li>Negative predictive value (NPV): 83%</li>
        </ul>
        <app-button text="View confusion matrix" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('4')" ></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
        <div class="bg-graphic desktop-only">
            <div class="c-graphics">
                <picture class="oval">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-01-desktop.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-01-desktop@2x.png">
                    <img src="assets/graphics/bg-oval-01-desktop@3x.png" alt="Oval graphic">
                </picture>
            </div>
        </div>
        <div class="bg-graphic-mobile mobile-only">
            <picture>
                <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-01-mobile.png">
                <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-01-mobile@2x.png">
                <img src="assets/graphics/bg-oval-01-mobile@3x.png" alt="Oval graphic">
            </picture>
        </div>
    </div>
    <!-- Table 5 -->
    <app-table5 *ngIf="tables[5]" (closeModalEvent)="closeTable()" ></app-table5>
    <div class="variable variable--5">
        <img src="assets/images/train-tune.svg" class="variable-graphic" alt="Train tune">
        <h3 class="development__subtitle">
            5. Train/tune a "no-imaging" CART
        </h3>
        <p class="development__copy">An additional CART model was trained, using 42 variables in which pancreatic imaging variables (n=7) had been removed. Performance characteristics of  the additional CART without pancreas imaging variables are shown below:</p>
        <ul class="development__list">
            <li>EPI misclassification rate (training error rate): 0.19</li>
            <li>Sensitivity: 87%</li>
            <li>Specificity: 73%</li>
            <li>Positive Predictive Value (PPV): 82%</li>
            <li>Negative Predictive Value (NPV): 80%</li>
        </ul>
        <app-button text="View confusion matrix" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('5')" ></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
        <div class="bg-graphic-mobile mobile-only">
            <picture>
                <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-02-mobile.png">
                <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-02-mobile@2x.png">
                <img src="assets/graphics/bg-oval-02-mobile@3x.png" alt="Oval graphic">
            </picture>
        </div>
    </div>
    <!-- Table 6 -->
    <app-table6 *ngIf="tables[6]" (closeModalEvent)="closeTable()"></app-table6>
    <div class="variable variable--6">
        <img src="assets/images/validation.svg" class="variable-graphic" alt="Validation">
        <h3 class="development__subtitle">
            6. Validation
        </h3>
        <p class="development__copy">Each CART model was validated using 5 fold-cross validation to assess generalizability.</p>
        <app-button text="View five-fold cross-validation" icon="assets/icons/icon-plus.svg" variation="button--table" (btnClick)="openTable('6')" ></app-button>
        <picture>
            <source media="(max-width: 360px)" srcset="assets/graphics/arrow-mobile.png">
            <img class="arrow-mobile mobile-only" src="assets/graphics/arrow-mobile@2x.png" alt="About this tool image">
        </picture>
        <div class="bg-graphic desktop-only">
            <div class="c-graphics">
                <picture class="oval">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/bg-oval-04-desktop.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/bg-oval-04-desktop@2x.png">
                    <img src="assets/graphics/bg-oval-04-desktop@3x.png" alt="Oval graphic">
                </picture>
                <picture class="infographic">
                    <source media="(max-width: 1440px)" srcset="assets/graphics/infographic-03.png">
                    <source media="(max-width: 2880px)" srcset="assets/graphics/infographic-03@2x.png">
                    <img src="assets/graphics/infographic-03@3x.png" alt="Infographic">
                </picture>
            </div>
        </div>
    </div>
    <!-- Table 7 -->
    <div class="variable variable--7">
        <img src="assets/images/integration.svg" class="variable-graphic" alt="Integration">
        <h3 class="development__subtitle">
            7. Integration
        </h3>
        <p class="development__copy">The two CART models were integrated into one EPI screening tool application.</p>
    </div>
</div>
<!-- Ready to begin? Banner -->
<div class="banner banner--ready-to-begin">
    <div class="banner__info">
        <h3 class="banner__title">Ready to begin?</h3>
        <p class="banner__text">If you have viewed the <a (click)="openVideoModal()">Screen for EPI in CP tool User Guide</a> and have all the information you need, click below to start using the Screen for EPI in CP tool</p>
        <app-button text="Start screening" path="screening-tool-landing" tab="start-screening" (btnClick)="trackCta('developing-the-tool-start-screening-cta')"></app-button>
    </div>
</div>
<!-- Considerations Banner -->
<div class="banner banner--considerations">
    <h2 class="banner__subtitle">Considerations for clinical use of the Screen for EPI in CP tool</h2>
    <p class="banner__copy">For a screening tool to be useful, the sum of sensitivity + specificity should be at least 1.5<sup>4</sup>, being 1.68 for the full CART and 1.60 for the no-imaging CART.  In addition, prevalence (or pre-test probability) of the disease (EPI) in the target population affects the predictive values. With the sensitivity and specificity of the EPI screening tool in the 80-90% range and the EPI prevalence of 58%  in the development cohort of the screening tool (EPI is uncertain, 34-66% prevalence range) the PPV is 86%. If the EPI prevalence would be 20% (EPI is unlikely, 10-33%  prevalence range) the PPV would only be 51%<sup>4,5</sup>.</p>
</div>
<!-- Additional Information Columns -->
<div class="c-columns c-columns--development">
    <h2>Additional Information</h2>
    <div class="column">
        <h4 class="column__title">Considerations & limitations</h4>
        <p class="column__copy">Additional information on the methodological considerations and limitations</p>
        <app-button text="Find out more" path="development" tab="considerations-limitations" (btnClick)="trackCta('developing-the-tool-considerations-limitations-cta')"></app-button>
    </div>
    <div class="column">
        <h4 class="column__title">Collaborators & publications</h4>
        <p class="column__copy collaborators">Several pancreatology experts were involved in the development of the Screen for EPI in CP tool.</p>
        <app-button text="Find out more" path="development" tab="collaborators-publications" (btnClick)="trackCta('developing-the-tool-collaborators-publications-cta')"></app-button>
    </div>
</div>
<app-bottom-navigation backRoute="what-is-epi" backText="What is EPI?" continueRoute="development" continueTab="considerations-limitations" continueText="Considerations & limitations"></app-bottom-navigation>
<app-references [references]="['Othman1', 'Othman2', 'Forsmark', 'PowerFellWright', 'MedowLucey']"></app-references>
<!-- Video Modal -->
<app-modal *ngIf="isVideoModalOpen" class="video-modal" (modalClose)="hideVideoModal()">
    <app-video-player analyticsTitle="User guide: How to use the Screen for EPI in CP tool" [video]="{ brightcoveAccountId: '1029485116001', brightcovePlayerId: 'default', videoId: '6322975218112'}"></app-video-player>
</app-modal>